import { getMarksBetween, belongsTo } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
const defaultOption = {
    inline: true,
    block: true,
    exclude: ['g_importantMarks'],
};
/**
 * 格式刷插件
 */
export class PaintFormatPlugin {
    constructor(opt = {}) {
        this.name = 'paintFormat';
        this.active = false;
        this.cachedTextNode = null;
        this.cachedTextBlock = null;
        this.toggleActive = (active) => {
            this.active = active !== null && active !== void 0 ? active : !this.active;
            if (this.active) {
                const { from, to } = this.editor.selection();
                let firstTextNode = null;
                let prevNode = null;
                this.editor.doc.nodesBetween(from, to, (node) => {
                    if (firstTextNode) {
                        return false;
                    }
                    if (node.isText) {
                        firstTextNode = node;
                    }
                    else {
                        prevNode = node;
                    }
                    return undefined;
                });
                this.cachedTextNode = firstTextNode;
                this.cachedTextBlock = prevNode;
            }
            else {
                this.cachedTextNode = null;
                this.cachedTextBlock = null;
            }
            this.editor.emit('paintformatactivechange', !!this.active);
        };
        this.handleMouseUp = () => {
            if (!this.active) {
                return false;
            }
            this.doPaint();
            if (this.active !== 'sticky') {
                this.toggleActive();
            }
            return false;
        };
        this.doPaint = () => {
            if (!this.active) {
                return false;
            }
            this.editor.dispatch((tr) => {
                const { ranges } = tr.selection;
                const { cachedTextNode, cachedTextBlock } = this;
                ranges.forEach((range) => {
                    const from = range.$from.pos;
                    const to = range.$to.pos;
                    // 下面先刷块后刷行内样式，避免某些 mark 不适用原 node 导致刷不上，如用有色段落刷代码块
                    const paintBlockType = cachedTextBlock && this.opt.block
                        ? () => {
                            // 刷块类型和块属性
                            tr.doc.nodesBetween(from, to, (node, pos, parent, index) => {
                                if (node.isTextblock) {
                                    // 需要同时满足原父级允许新类型+新类型允许原内容
                                    const canChangeType = (parent === null || parent === void 0 ? void 0 : parent.canReplaceWith(index, index + node.nodeSize, cachedTextBlock.type)) && cachedTextBlock.type.validContent(node.content);
                                    tr.setNodeMarkup(pos, canChangeType ? cachedTextBlock.type : undefined, cachedTextBlock.attrs);
                                }
                            });
                        }
                        : noop;
                    const paintMarks = cachedTextNode && this.opt.inline
                        ? () => {
                            // 刷行内样式，注意配置在 exclude 中的样式不会被清除或覆盖，即应保持原样
                            const marks = getMarksBetween(from, to, tr.doc).map((range) => range.mark);
                            marks.forEach((mark) => {
                                if (!belongsTo(mark, this.opt.exclude)) {
                                    tr.removeMark(from, to, mark);
                                }
                            });
                            cachedTextNode.marks.forEach((mark) => {
                                if (belongsTo(mark, this.opt.exclude)) {
                                    return;
                                }
                                tr.addMark(from, to, mark);
                            });
                        }
                        : noop;
                    paintBlockType();
                    paintMarks();
                    // 刷过 mark 后原先不适合的 blockType 可能变得适合，所以再刷一次块
                    paintBlockType();
                });
            });
            return true;
        };
        this.opt = {
            ...defaultOption,
            ...opt,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                toggleActive: this.toggleActive,
                doPaint: this.doPaint,
            },
            handleDOMEvents: {
                mouseup: this.handleMouseUp,
            },
            shortcuts: {
                Escape: () => {
                    if (this.active) {
                        this.toggleActive();
                        return true;
                    }
                    return false;
                },
            },
        };
    }
    renderToolbarItem() {
        const t = this.editor.t.bind(this.editor);
        const btn = document.createElement('exeditor-toolbar-button');
        const tip = t('格式刷，双击可重复使用');
        const exitTip = `${t('点击退出格式刷')}(Esc)`;
        Object.assign(btn, {
            label: tip,
            onclick: () => {
                this.editor.focus();
                this.toggleActive();
            },
            ondblclick: () => {
                this.editor.focus();
                this.toggleActive('sticky');
            },
        }).append(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.paintIcon),
        }));
        this.editor.on('paintformatactivechange', (active) => {
            btn.active = active;
            btn.label = active ? exitTip : tip;
            // TODO 换个更好的光标图片
            this.editor.getRootDOM().style.cursor = active ? 'default' : '';
        });
        return btn;
    }
}
function noop() { }
//# sourceMappingURL=index.js.map